import React, { useEffect, useLayoutEffect, useState } from 'react';
import {
	CountryRegions,
	updateMerchantGiftcards,
	getGiftcards,
} from '../../../actions/auth';
import Header from '../../layout/Header';
import { useDispatch } from 'react-redux';
import GiftcardsCard from './GiftcardCard';
import { decrypt } from '../../../utils/encodingdecoding';
import swal from 'sweetalert';

const Giftcards = () => {
	const [loader, setLoader] = useState(false);
	const [giftCardsList, setGiftCardsList] = useState(null);
	const [isSelected, setIsSelected] = useState([]);

	const selectedGiftCard = isSelected.filter((item) => item.status);
	const dispatch = useDispatch();

	const [countryRelatedData, setCountryRelatedData] = useState({
		allCountry: [],
		countrySearchKeyword: '',
		selectedCountry: '',
	});

	const countryOptions = countryRelatedData.countrySearchKeyword
		? countryRelatedData.allCountry.filter((item) =>
			item.label
				.toLowerCase()
				.includes(
					countryRelatedData.countrySearchKeyword.toLowerCase(),
				),
		)
		: countryRelatedData.selectedCountry
			? [
				countryRelatedData.allCountry.find(
					(item) =>
						item.value.toLowerCase() ===
						countryRelatedData.selectedCountry.toLowerCase(),
				),
				...countryRelatedData.allCountry
					.slice(0, 10)
					.filter(
						(_item) =>
							_item.value.toLowerCase() !==
							countryRelatedData.selectedCountry.toLowerCase(),
					),
			]
			: countryRelatedData.allCountry.slice(0, 10);

	const [card, setCard] = useState({
		getSearchedCard: [],
		cardFlag: false,
	});

	const { getSearchedCard, cardFlag } = card;

	const getCountry = async () => {
		setLoader(true);
		const token = JSON.parse(localStorage.getItem('token_gen'));
		let res = await CountryRegions(token?.access_token);
		const country = res?.map((val) => ({
			value: val.name,
			label: val.englishName,
			symbol: val.isoCurrencySymbol,
			isChecked: false,
		}));

		setCountryRelatedData((prev) => ({
			...prev,
			allCountry: country,
		}));

		setLoader(false);
	};

	useLayoutEffect(() => {
		getCountry();
	}, []);

	const searchCountry = (e) => {
		setCountryRelatedData((prev) => ({
			...prev,
			countrySearchKeyword: e.target.value,
		}));
	};
	const handleCardSearch = (e) => {
		let temp = [];
		const allGiftCards = Object.values(giftCardsList).flat();
		if (e.target.value) {
			allGiftCards?.filter((str) => {
				if (
					str.title
						.toLowerCase()
						.includes(e.target.value.toLowerCase())
				) {
					temp.push(str);
				}
			});
			setCard({ ...card, getSearchedCard: temp, cardFlag: true });
		} else {
			setCard({ ...card, getSearchedCard: temp, cardFlag: false });
		}
	};

	const toggleCountry = (e, value) => {
		setCountryRelatedData((prev) => {
			const lowerValue = value.toLowerCase();

			// Find the selected country
			const index = prev.allCountry.findIndex(
				(item) => item.value.toLowerCase() === lowerValue,
			);
			if (index === -1) return prev;

			const clickedCountry = prev.allCountry[index];
			const isSelectingSame = clickedCountry.isChecked;

			// Build new allCountry array — only one checked at a time
			const updatedAllCountry = prev.allCountry.map((country) => ({
				...country,
				isChecked:
					country.value.toLowerCase() === lowerValue
						? !isSelectingSame
						: false,
			}));

			return {
				...prev,
				allCountry: updatedAllCountry,
				selectedCountry: isSelectingSame ? '' : clickedCountry.value,
			};
		});
	};

	useEffect(() => {
		if (countryRelatedData.selectedCountry) {
			dispatch(
				getGiftcards(
					{ country: countryRelatedData.selectedCountry },
					setGiftCardsList,
					setLoader,
				),
			);
		} else {
			setGiftCardsList(null);
		}
	}, [countryRelatedData.selectedCountry]);

	useEffect(() => {
		if (giftCardsList) {
			const allGiftCards = Object.values(giftCardsList).flat();
			setIsSelected(
				allGiftCards
					.filter((item) => {
						const isClientExits =
							'client_details' in item &&
							Object.keys(item.client_details).includes(
								decrypt(localStorage.getItem('clientid')),
							);
						return (
							isClientExits &&
							item.client_details[
								decrypt(localStorage.getItem('clientid'))
							].status
						);
					})
					.map((_item) => ({
						..._item,
						..._item['client_details'][
						decrypt(localStorage.getItem('clientid'))
						],
					})),
			);
		}
	}, [giftCardsList]);

	const handleCategory = (e, category, category_name) => {
		if (category === 'selectAll') {
			const allCardsSelected = e.target.checked;
			const allGiftCards = Object.values(giftCardsList).flat();

			if (allCardsSelected) {
				setIsSelected(allGiftCards);
			} else {
				setIsSelected([]);
			}
		} else {
			const temp = isSelected.filter(
				(item) => !category.includes(item.code),
			);
			if (e.target.checked) {
				setIsSelected((prev) => [
					...temp,
					...giftCardsList[category_name],
				]);
			} else {
				// setIsSelected(temp);
				setIsSelected((prev) =>
					prev.map((item) => ({
						...item,
						status: category.includes(item.code) ? 0 : item.status,
					})),
				);
			}
		}
	};

	const handleSelect = async (id, fromSearch, giftCardDetails) => {
		let searchCat = [];
		let newObject;
		let index;
		if (fromSearch) {
			let updatedArray = [];
			let temp = {
				discount: 0,
				status: 1,
				...giftCardDetails,
			};
			index = isSelected.findIndex(
				(item) => item.id === id && item.code === temp.code,
			);
			if (index === -1) {
				searchCat.push(temp);
			} else {
				// updatedArray = isSelected?.filter((item) => item.id !== id);
				updatedArray = isSelected.map((item, i) =>
					i === index
						? { ...item, status: item.status === 1 ? 0 : 1 }
						: item,
				);
			}
			index === -1
				? setIsSelected([...isSelected, ...searchCat])
				: setIsSelected(updatedArray);
		} else {
			newObject = {
				discount: 0,
				status: 1,
				...giftCardDetails,
			};
			index = isSelected.findIndex(
				(item) =>
					item.id === newObject.id && item.code === newObject.code,
			);
			if (index === -1) {
				setIsSelected([...isSelected, newObject]);
			} else {
				// const updatedArray = isSelected?.filter(
				// 	(item) =>
				// 		item.id !== newObject.id ||
				// 		item.category !== newObject.category,
				// );
				setIsSelected((prev) =>
					prev.map((item, i) =>
						i === index
							? { ...item, status: item.status === 1 ? 0 : 1 }
							: item,
					),
				);
			}
		}
	};

	const onSubmit = async () => {
		if (Array.isArray(isSelected) && !isSelected.length) {
			swal({
				position: 'center',
				icon: 'info',
				title: 'Please select at least one gift card.',
				showConfirmButton: false,
				timer: 3000,
			});
			return;
		}
		dispatch(
			updateMerchantGiftcards(
				{
					giftcard_list: isSelected.map((item) => ({
						id: item.id,
						status: item.status,
						discount: item.discount,
					})),
					client_id: localStorage.getItem('clientid'),
				},
				setLoader,
			),
		);
	};
	return (
		<>
			<Header name={'Gift Card'} />
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div className='dashboard__content'>
				<div className='giftcard_mainbox'>
					<div className='gc_sidebar'>
						<h5 className='countryLabel'> Country</h5>
						<input
							className='form-control'
							onChange={searchCountry}
							type='text'
							placeholder='Enter Country'
						/>

						{Array.isArray(countryOptions) &&
							countryOptions.length ? (
							<div className='form-group'>
								<div className='country-select-form-box'>
									{countryOptions.map((ele, i) => (
										<ul key={i}>
											<li>{ele.label}</li>
											<input
												type='checkbox'
												value={
													ele.isChecked
														? ''
														: ele.value
												}
												name='isChecked'
												checked={ele.isChecked}
												onChange={(e) =>
													toggleCountry(e, ele.value)
												}
											/>
										</ul>
									))}
									{!countryRelatedData.countrySearchKeyword && (
										<p>Search More Countries..........</p>
									)}
								</div>
							</div>
						) : (
							<></>
						)}
					</div>
					{giftCardsList &&
						Object.entries(giftCardsList).length > 0 ? (
						<div className='gc_contentbox'>
							<div className='gc_content_pbox'>
								<input
									className='form-control'
									type='text'
									id='gift_card'
									onChange={handleCardSearch}
									placeholder='Search Gift Cards/Vouchers'
								/>
								{cardFlag ? (
									getSearchedCard?.length ? (
										<>
											<div className='campaignSelection__boxes'>
												<div className='gc_inmainbox'>
													{getSearchedCard.map(
														(value, i) => (
															<div
																key={i}
																className='gc_innbox'>
																<GiftcardsCard
																	item={value}
																	getSearchedCountry={
																		countryOptions
																	}
																	handleSelect={
																		handleSelect
																	}
																	isSelected={
																		isSelected
																	}
																	value={
																		value.code
																	}
																	fromSearch={
																		true
																	}
																	country={
																		countryRelatedData.selectedCountry
																	}
																/>
															</div>
														),
													)}
												</div>
											</div>
											<div
												className='row'
												style={{
													paddingBottom: '20px',
												}}>
												<div className='col-sm-12  col-md-12 col-lg-12 col-xl-12'>
													<div
														className='button-section'
														style={{
															display: 'flex',
															justifyContent:
																'flex-end',
														}}>
														<button
															type='submit'
															onClick={onSubmit}
															className='btn btn-primary'>
															Update
														</button>
													</div>
												</div>
											</div>
										</>
									) : (
										<span>Not found</span>
									)
								) : (
									<div>
										<div className='select_all_giftcard'>
											<div>Select All</div>{' '}
											<input
												type='checkbox'
												checked={
													selectedGiftCard.length ===
														Object.values(
															giftCardsList,
														).flat().length
														? true
														: false
												}
												onChange={(e) =>
													handleCategory(
														e,
														'selectAll',
													)
												}
											/>
										</div>
										<div
											className='accordion'
											id='accordionExample'>
											{giftCardsList &&
												Object.keys(giftCardsList)?.length >
												0 ? (
												<div className='accordion-item'>
													<h2
														className='accordion-header'
														id='staticAccordion'>
														<button
															className='accordion-button'
															type='button'
															data-bs-toggle='collapse'
															data-bs-target='#staticCollapse'
															aria-expanded='false'
															aria-controls='staticCollapse'>
															Selected Gift Card (
															{
																selectedGiftCard.length
															}
															)
														</button>
													</h2>
													<div
														id='staticCollapse'
														className='accordion-collapse collapse'
														aria-labelledby='staticAccordion'>
														<div className='accordion-body'>
															{selectedGiftCard?.length >
																0 ? (
																<div className='campaignSelection__boxes'>
																	<div className='gc_inmainbox'>
																		{selectedGiftCard?.map(
																			(
																				selectedItem,
																				index,
																			) => {
																				return (
																					<div
																						key={
																							index +
																							selectedItem.id
																						}
																						className='gc_innbox'>
																						<GiftcardsCard
																							item={
																								selectedItem
																							}
																							getSearchedCountry={
																								countryOptions
																							}
																							handleSelect={
																								handleSelect
																							}
																							isSelected={
																								isSelected
																							}
																							value={
																								selectedItem.code
																							}
																							fromSearch={
																								false
																							}
																							country={
																								countryRelatedData.selectedCountry
																							}
																						/>
																					</div>
																				);
																			},
																		)}
																	</div>
																</div>
															) : (
																<div>
																	<p>
																		No gift
																		card
																		selected
																		yet
																	</p>
																</div>
															)}
														</div>
													</div>
												</div>
											) : null}

											{Object.entries(giftCardsList)?.map(
												(item, i) => {
													const category_code =
														item[1].map(
															(_obj) => _obj.code,
														);
													const selectedGiftCardsLength =
														isSelected.filter(
															(obj) =>
																category_code.includes(
																	obj.code,
																) && obj.status,
														).length;
													return (
														<div
															className='accordion-item'
															key={i}>
															<h2
																className='accordion-header'
																id={i}>
																<button
																	className='accordion-button collapsed'
																	type='button'
																	data-bs-toggle='collapse'
																	data-bs-target={`#${item[0].replace(
																		/[^a-zA-Z0-9]/g,
																		'',
																	)}`}
																	aria-expanded='false'
																	aria-controls={
																		item[0]
																	}>
																	{item[0] +
																		'  (' +
																		item[1]
																			.length +
																		')'}
																</button>
																<input
																	type='checkbox'
																	name={
																		item[0]
																	}
																	checked={
																		selectedGiftCardsLength ===
																			item[1]
																				.length ||
																			selectedGiftCard.length ===
																			Object.values(
																				giftCardsList,
																			).flat()
																				.length
																			? true
																			: false
																	}
																	onChange={(
																		e,
																	) =>
																		handleCategory(
																			e,
																			category_code,
																			item[0],
																		)
																	}
																/>
															</h2>

															<div
																id={item[0].replace(
																	/[^a-zA-Z0-9]/g,
																	'',
																)}
																className='accordion-collapse collapse'
																aria-labelledby={`#${i}`}
																data-bs-parent='#accordionExample'>
																<div className='accordion-body'>
																	<div className='campaignSelection__boxes'>
																		<div className='gc_inmainbox'>
																			{item[1].map(
																				(
																					value,
																					_i,
																				) => (
																					<div
																						key={
																							_i
																						}
																						className='gc_innbox'>
																						<GiftcardsCard
																							item={
																								value
																							}
																							getSearchedCountry={
																								countryOptions
																							}
																							handleSelect={
																								handleSelect
																							}
																							isSelected={
																								isSelected
																							}
																							value={
																								value.code
																							}
																							fromSearch={
																								false
																							}
																							country={
																								countryRelatedData.selectedCountry
																							}
																						/>
																					</div>
																				),
																			)}
																		</div>
																	</div>
																</div>
															</div>
														</div>
													);
												},
											)}
										</div>

										{loader ? (
											''
										) : (
											<div
												className='row'
												style={{
													paddingBottom: '20px',
												}}>
												<div className='col-sm-12  col-md-12 col-lg-12 col-xl-12'>
													<div
														className='button-section'
														style={{
															display: 'flex',
															justifyContent:
																'flex-end',
														}}>
														<button
															type='submit'
															onClick={onSubmit}
															className='btn btn-primary'>
															Update
														</button>
													</div>
												</div>
											</div>
										)}
									</div>
								)}
							</div>
						</div>
					) : (
						<div className='gc_contentbox'>
							<div className='gc_content_pbox'>
								<h4 className='countryLabel'>
									Please select a country
								</h4>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default Giftcards;

